import React from 'react';
import './SplashScreen.css';

export default function SplashScreen({ isLoading, forceVisible = false }) {
  if (!isLoading) return null;

  const splashClassName = forceVisible ? 'splash-screen splash-screen--force' : 'splash-screen';

  return (
    <div className={splashClassName} role="status" aria-live="polite" aria-label="Loading">
      <div className="splash-content">
        <img
          src="/favicons/rocket-ico.png"
          alt="Loading"
          className="splash-icon"
        />
      </div>
    </div>
  );
}
